import { useCallback, useEffect, useMemo, useRef } from "react";
import { useAppSelector } from "src/redux/hooks/redux";
import { gatewayPhone } from "src/gateways/gatewayPhone";
import { webrtcTabSession } from "../_utils/webrtcTabSession.utils";

const HEARTBEAT_INTERVAL_MS = 20_000;

export const useWebRTCSessionHeartbeat = (enabled = true) => {
  const companies = useAppSelector((state) => state.userState.companies);

  const companiesId = useMemo(
    () => companies.map((c) => c.companyId),
    [companies]
  );

  const token =
    typeof window !== "undefined" ? sessionStorage.getItem("token") : null;

  const hasCredentials = Boolean(companiesId.length && token);

  const companiesIdRef = useRef(companiesId);
  const tokenRef = useRef(token);
  const hasCredentialsRef = useRef(hasCredentials);

  useEffect(() => {
    companiesIdRef.current = companiesId;
    tokenRef.current = token;
    hasCredentialsRef.current = hasCredentials;
  });

  const sendHeartbeat = useCallback(async () => {
    const ids = companiesIdRef.current;
    const tok = tokenRef.current;
    if (!ids.length || !tok) return;

    await Promise.all(
      ids.map((id) =>
        gatewayPhone
          .post("/webrtc/session/heartbeat", { companyId: id })
          .catch(() => { })
      )
    );
  }, []);

  const sendDisconnect = useCallback(async () => {
    if (!hasCredentialsRef.current) return;
    const ids = companiesIdRef.current;
    if (!ids.length) return;

    await Promise.all(
      ids.map((id) =>
        gatewayPhone
          .post("/webrtc/session/disconnect", { companyId: id })
          .catch(() => { })
      )
    );
    hasCredentialsRef.current = false;
  }, []);

  useEffect(() => {
    if (!enabled || !hasCredentials) return;

    void sendHeartbeat();
    const id = window.setInterval(() => void sendHeartbeat(), HEARTBEAT_INTERVAL_MS);

    return () => {
      clearInterval(id);
      if (webrtcTabSession.isOnlyOpenTab()) {
        webrtcTabSession.notifyTabClosing();
        void sendDisconnect();
      }
    };
  }, [enabled, hasCredentials]);
};